export default __webpack_public_path__ + "static/media/subSection-picture.c578e315.jpg";